<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header text-center">
          <i class="fas fas-align-justify"></i>
          Your account(s)
          {{ this.selectedCustomer?.custName }}
        </div>
        <div class="card-body">
          <div class="row justify-content-center" *ngIf="customers?.length > 0">
            <div class="col-4">
              <label class="col-form-label d-block text-center">
                Please select an account
                <ng-select
                  [items]="customers"
                  bindLabel="custName"
                  bindValue="id"
                  [appearance]="'outline'"
                  [(ngModel)]="selectedCustomerId"
                  (change)="displayCustomer()"
                  [required]="true">
                </ng-select>
              </label>
            </div>
          </div>
          <hr *ngIf="this.selectedCustomer !== null && this.selectedCustomer?.id">
          <div class="row" *ngIf="this.selectedCustomer !== null && this.selectedCustomer?.id">
            <div class="row">
              <div class="col">
                <labeled-display
                  [name]="'Customer Name'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.custName"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Company Name'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.companyName"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Invoice Name'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.invoiceName"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Park Group'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.parkGroup?.name || 'Standard'"></labeled-display>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <labeled-display
                  [name]="'House Name'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.houseName"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Street'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.street"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Area'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.area"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Town'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.town"></labeled-display>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <labeled-display
                  [name]="'County'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.county"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Postcode'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.postcode"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Telephone'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.homeTelephone"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Email'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.email"></labeled-display>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <labeled-display
                  [name]="'Assigned Rep'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="(selectedCustomer?.rep?.firstName ?? '') + ' ' + (selectedCustomer?.rep?.lastName ?? '')"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Rep Email'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.rep?.email"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Rep Phone'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="selectedCustomer?.rep?.mobileNumber"></labeled-display>
              </div>
              <div class="col text-center" *ngIf="selectedCustomer?.rep?.email">
                <a class="btn btn-primary mt-4" href='mailto:sales@fitrite.info?subject=Help&body=Hello!'>Email Rep</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

